<div class="grid {class} grid--direction-{direction}">

    <slot></slot>

</div>

<style>
    @media screen and (min-width: 80rem) {
        .grid {
            display: flex;
        }

        .grid--direction-row {
            flex-direction: row;
        }

        .grid--direction-row-reverse {
            flex-direction: row-reverse;
        }
    }    
</style>

<script>
    export default {
        data() {
            return {
                class: '',
                direction: 'row'
            }
        }
    }
</script>